<router-outlet></router-outlet>

<!-- <button class="bell" *ngIf="!isNotificationPermissionGranted" (click)="requestPermission()">
    <img src="assets/images/bell.png" />
</button> -->